import { useSocket } from '../contexts/SocketContext';

export function WebSocketStatus() {
  const { connected } = useSocket();

  return (
    <div style={{
      position: 'fixed',
      bottom: '1rem',
      right: '1rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.5rem 0.75rem',
      backgroundColor: connected ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
      border: `1px solid ${connected ? 'var(--success)' : 'var(--danger)'}`,
      borderRadius: '0.5rem',
      fontSize: '0.875rem',
      fontWeight: '500',
      color: connected ? 'var(--success)' : 'var(--danger)',
      zIndex: 1000,
      boxShadow: 'var(--shadow-md)',
    }}>
      <div style={{
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: connected ? 'var(--success)' : 'var(--danger)',
        animation: connected ? 'none' : 'pulse 2s ease-in-out infinite',
      }} />
      <span>{connected ? 'Verbunden' : 'Getrennt'}</span>
    </div>
  );
}
